// extracted by mini-css-extract-plugin
export default {"MethodologySection__criteriaCardContainer":"MethodologySection-styles__MethodologySection__criteriaCardContainer__aKinc"};